export interface HintPanelProps {
  header?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const HintPanel: React.FC<HintPanelProps> = ({ header, children, className }) => (
  <div
    className={`border-grey-main relative rounded-sm border-1 border-solid text-center ${className}`}
  >
    {header && (
      <div className="bg-color-background-base absolute left-1/2 -translate-x-1/2 -translate-y-1/2 transform px-2">
        {header}
      </div>
    )}
    <div className="p-2">{children}</div>
  </div>
);
